import React, { FC, memo } from 'react';
import { Container } from './styles';
import { Props } from './types';

const Ellipsis: FC<Props> = ({ ...rest }) => (
  <Container {...rest}>&hellip;</Container>
);

export default memo(Ellipsis);
